import style from './close.module.css';

interface CloseProps {
  iconColor: 'black' | 'white';
}

const iconColorMap: Record<CloseProps['iconColor'], string> = {
  black: style.closeBlack,
  white: style.closeWhite,
};

const Close = ({
  iconColor,
}: CloseProps) => {
  return (
    <svg
      className={iconColorMap[iconColor]}
      fill="none"
      height={24}
      viewBox="0 0 25 24"
      width={25}
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        stroke="currentColor"
        strokeWidth={2}
        x1="1.29289"
        x2="22.5061"
        y1="22.5061"
        y2="1.29289"
      />
      <line
        stroke="currentColor"
        strokeWidth={2}
        x1="2.70711"
        x2="23.9203"
        y1="1.50609"
        y2="22.7193"
      />
    </svg>
  );
};

export default Close;
